import { withAssetPrefix } from '@/HOC';
import Image from 'next/image';

const StaticImage = (props) => {
  const { useNextImage = false, ...otherProps } = props;
  return useNextImage ? <Image alt="image" {...otherProps} /> : <img alt="image" {...otherProps} />;
};

export default withAssetPrefix(StaticImage);
